<template>
    <div class="input-group">
        <span class="input-group-addon" @click="open"><i class="icon icon-passenger" /></span>
        <div v-if="!$device.mobile" class="v-dropdown mt-1" ref="dropdown">
            <div class="p-2 clearfix">
                <search-passengers-room
                    v-for="(room, index) in rooms"
                    :key="index"
                    :index="index"
                    :room="room"
                    :show-delete="rooms.length > 1"
                    @increase="increaseCount"
                    @decrease="decreaseCount"
                    @remove="removeRoom(index)"
                />
                <hr class="my-0">
                <div class="m-2 mt-3">
                    <button type="button" class="btn btn-primary btn-outline btn-block" @click="addRoom">
                        <i class="icon-plus v-middle" /> اضافه کردن اتاق
                    </button>
                </div>
            </div>
        </div>
        <bottom-up-modal v-else :show.sync="showModal">
            <strong slot="title">
                <i class="icon icon-user-account text-orange font-20 ml-1 v-middle" />
                انتخاب مسافر و اتاق
            </strong>
            <div class="clearfix">
                <search-passengers-room
                    v-for="(room, index) in rooms"
                    :key="index"
                    :index="index"
                    :room="room"
                    :show-delete="rooms.length > 1"
                    @increase="increaseCount"
                    @decrease="decreaseCount"
                    @remove="removeRoom(index)"
                />
                <div class="py-3">
                    <button type="button" class="btn btn-primary btn-outline btn-block mb-2" @click="addRoom">
                        <i class="icon-plus v-middle" /> اضافه کردن اتاق
                    </button>
                    <button type="button" @click="showModal = false" class="btn btn-block btn-success">
                        تایید
                    </button>
                </div>
            </div>
        </bottom-up-modal>
        <input
            type="text"
            name="passengers"
            class="form-control"
            placeholder="مسافران"
            :tabindex="tabindex"
            @click.prevent="showModal = $device.mobile"
            readonly
            ref="input"
            :value="passengersText"
            v-dropdown.fade.toggle="() => $refs.dropdown"
            aria-describedby="search-passengers"
        >
    </div>
</template>

<script>
// node_modules
import { mapActions } from 'vuex';
import { roomsInfo } from '~/components/pages/international-hotel/utils';
// components
import SearchPassengersRoom from '~/components/pages/international-hotel/search/search-passengers-room';
import BottomUpModal from '~/components/common/modal/bottom-up-modal';

export default {
    components: {
        BottomUpModal,
        SearchPassengersRoom,
    },
    props: {
        value: {
            type: Array,
            required: true,
        },
        tabindex: {
            type: Number,
            default: null,
        },
    },
    data () {
        return {
            showModal: false,
        };
    },
    computed: {
        maxPassengers: () => 9,
        // calculate total passengers in all rooms
        totalPassengers () {
            return this.rooms.reduce((sum, room) => {
                sum += room.adults.length + room.children.length;
                return sum;
            }, 0);
        },
        adult () {
            return this.rooms.reduce((sum, room) => {
                sum += room.adults.length;
                return sum;
            }, 0);
        },
        child () {
            return this.rooms.reduce((sum, room) => {
                sum += room.children.length;
                return sum;
            }, 0);
        },
        // Passenger input placeHolder
        passengersText () {
            const { adultCount, childCount, roomCount } = roomsInfo(this.rooms);
            return (adultCount + ' بزرگسال') +
                (childCount > 0 ? ' ، ' + childCount + ' کودک' : '') +
                ' ، ' + (roomCount > 0 ? roomCount : '1') + ' ' + 'اتاق';
        },
        rooms: {
            get () {
                return this.value;
            },
            set (newValue) {
                this.$emit('input', newValue);
            },
        },
    },
    methods: {
        ...mapActions(['openAlert']),
        // checks room length be less than five
        checkRoomLength () {
            if (this.rooms.length >= 4) {
                this.openAlert('امکان اضافه کردن بیش از چهار اتاق میسر نمی‌باشد.');
                return false;
            }
            return true;
        },
        // add new room
        addRoom () {
            if (!this.checkRoomLength()) return;
            this.rooms.push({
                type: 'unspecified',
                adults: [30],
                children: [],
            });
        },
        // delete room
        removeRoom (index) {
            if (this.rooms.length > 1) {
                this.rooms.splice(index, 1);
            }
        },
        // increase number of passengers
        increaseCount (value) {
            const { index, type } = value;
            switch (type) {
            case 'adult':
                if (this.rooms[index].adults.length > 13) {
                    this.openAlert('تعداد بزرگسالان یک اتاق نباید بیشتر از 14 باشد.');
                } else {
                    this.rooms[index].adults.push(30);
                }
                break;
            case 'child':
                if (this.rooms[index].children.length > 5) {
                    this.openAlert('تعداد کودکان یک اتاق نباید بیشتر از 6 باشد.');
                } else {
                    this.rooms[index].children.push({ age: 0 });
                }
                break;

            default:
                return false;
            }
        },
        // decrease number of passenger
        decreaseCount ({ index, type }) {
            switch (type) {
            case 'adult':
                if (this.adult > 1 && this.rooms[index].adults.length > 1) {
                    this.rooms[index].adults.pop();
                } else {
                    if (this.rooms.length > 1) {
                        this.removeRoom(index);
                    } else {
                        this.openAlert('تعداد بزرگسالان نباید کمتر از 1 باشد.');
                    }
                }
                break;
            case 'child':
                if (this.child > 0) {
                    this.rooms[index].children.pop();
                    // let lastKid = this.rooms[index].childs.length - 1;
                    // this.rooms[index].childs.splice(lastKid, 1);
                }
                break;
            default:
                return false;
            }
        },
        open () {
            if (this.$device.mobile) {
                this.showModal = true;
            } else {
                this.$refs.input.click();
            }
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~vars';

.v-dropdown {
    min-width: 320px;
    margin-top: 5px;

    @media (min-width: 992px) {
        right: auto;
        left: 0;
    }

    &::before {
        content: '';
        display: block;
        width: 0;
        height: 0;
        border: 5px solid transparent;
        border-bottom-color: $snow-white;
        position: absolute;
        top: -10px;
        left: 10px;
        @media (min-width: 1200px) {
            right: 145px;
            left: auto;
        }
        z-index: 21;
    }

    &.up {
        margin-top: 0;
        margin-bottom: 5px;

        &::before {
            top: auto;
            bottom: -10px;
            border-top-color: $snow-white;
            border-bottom-color: transparent;
        }
    }
}
</style>
